import React from 'react'

const Catalogue = () => <div>{/*<img alt="cataloge" src={`${require('../../assets/ZadigCatalogue.jpg')}`} />*/}</div>

export default Catalogue
